<template>
  <slot />

  <!-- ITINERARY SUMMARY -->
  <ItinerarySummary
    :modelValue="itinerarySummaryStore.isOpen"
    @update:model-value="(value) => itinerarySummaryStore.toggle(value)"
  />
</template>

<script lang="ts" setup>
import { defineAsyncComponent, onMounted } from 'vue'
import useItinerarySummaryStore from '@/modules/Search/store/itinerarySummary'
import { useItinerary } from '@/modules/Search/composables'

const ItinerarySummary = defineAsyncComponent(
  () =>
    import('@/modules/Search/components/ItinerarySummary/ItinerarySummary.vue')
)

const itinerarySummaryStore = useItinerarySummaryStore()

const { enabled, fetchItinerary } = useItinerary()
const { refetch } = fetchItinerary()
onMounted(() => {
  if (enabled.value) {
    refetch()
  }
})
</script>
